import type { SVGProps } from 'react';

const SvgCrop54 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M21 4H3v16h18zm-2 14H5V6h14z" />
  </svg>
);
export default SvgCrop54;
